<template>
  <div>
     
     <div class="background">

       <b-overlay :show="loadingSensorList || loadingData"  no-wrap z-index=9 spinner-type="none"> </b-overlay>

         <b-container fluid>
         <b-row>
           <b-col class="RoundBox" cols="12" sm="12" md="12" lg="12">

              <b-table-simple small borderless caption-top responsive >
                <caption class="font-weight-bold">Sensors</caption>

                <b-tbody>
                  <b-tr> <b-th>Select sensor: </b-th> <b-td><b-form-select v-model="SensorPlaceholder" :options="availableSensors" v-on:change="SelectNewSensor"></b-form-select></b-td> </b-tr>  
                  <b-tr> <b-th>Select period: </b-th> <b-td><b-form-select v-model="periodPlaceholder" :options="periods" v-on:change="SetDateLimits"></b-form-select></b-td> </b-tr>  
                    
                </b-tbody>
              </b-table-simple>

           </b-col>
          </b-row>
          </b-container>

       
       <b-overlay :show="loadingSensorList" rounded="sm" no-wrap style="max-height: 500px">
        <template v-slot:overlay>
            <div class="text-center">
              <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
              <p id="cancel-label">Loading sensors from server. Please wait...</p>
                <b-button
                  ref="cancel"
                  variant="outline-danger"
                  size="sm"
                  aria-describedby="cancel-label"
                  @click="loadingSensorList = false; loadingData=false"
                >
                  Show page anyway
                </b-button>
            </div>
        </template>
      </b-overlay>

      


       <b-overlay :show="loadingData" rounded="sm" no-wrap style="max-height: 500px">
        <template v-slot:overlay>
            <div class="text-center">
              <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
              <p id="cancel-label">Loading data from server. Please wait...</p>
                <b-button
                  ref="cancel"
                  variant="outline-danger"
                  size="sm"
                  aria-describedby="cancel-label"
                  @click="loadingSensorList = false; loadingData=false"
                >
                  Show page anyway
                </b-button>
            </div>
        </template>
      </b-overlay>

       <b-container fluid>
         <b-row>
           <b-col class="RoundBox" cols="12" sm="6" md="6" lg="4"><Battery :datacollection="voltage_dataCollection" :last_online="sensor_last_online" :currentValue="voltage_current"></Battery></b-col>
           <b-col class="RoundBox" cols="12" sm="12" md="12" lg="8">
             <GeneralPlot :GraphTitle="Tot_Title" :options="KUTh_options" :datacollection="Tot_dataCollection" ref="totalPlot"></GeneralPlot>
             <b-button hidden :pressed.sync="ToggleTotalCounts" v-on:click="UpdateTotCntPlot" variant="primary"> Plotted as: {{ TotalCountsState }}</b-button>
            </b-col>      
           
           <b-col class="RoundBox" cols="12" sm="6" md="6" lg="4"><GeneralPlot :GraphTitle="K_Title" :options="KUTh_options" :datacollection="K_dataCollection" ref="kPlot"></GeneralPlot></b-col>
           <b-col class="RoundBox" cols="12" sm="6" md="6" lg="4"><GeneralPlot :GraphTitle="U_Title" :options="KUTh_options" :datacollection="U_dataCollection" ref="uPlot"></GeneralPlot></b-col>
           <b-col class="RoundBox" cols="12" sm="6" md="6" lg="4"><GeneralPlot :GraphTitle="Th_Title" :options="KUTh_options" :datacollection="Th_dataCollection" ref="thPlot"></GeneralPlot></b-col> 

           <b-col class="RoundBox" cols="12" sm="6" md="6" lg="4"><GeneralPlot :GraphTitle="'Pressure'" :options="KUTh_options" :datacollection="pressure_dataCollection" ref="pressPlot"></GeneralPlot></b-col>
           <b-col class="RoundBox" cols="12" sm="6" md="6" lg="4"><GeneralPlot :GraphTitle="'Temperature'" :options="KUTh_options" :datacollection="Temperature_dataCollection" ref="tempPlot"></GeneralPlot></b-col>
           <b-col class="RoundBox" cols="12" sm="6" md="6" lg="4"><GeneralPlot :GraphTitle="'Humidity'" :options="KUTh_options" :datacollection="Humidity_dataCollection" ref="humPlot"></GeneralPlot></b-col> 

 
         </b-row>

      </b-container>



    </div>
  </div>
</template>

<script>

// app.js
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import axios from 'axios';


import Battery from './Battery.vue'
import GeneralPlot from './GeneralPlot.vue'


import {SENSOR_REQUEST, SENSOR_SELECT} from '@/store/actions/sensors'




export default {
  name: 'gSMS',
  data: function() {
    return {
      cutoffPlaceholder : 0,
      periodPlaceholder : 7,
      periods: [
          { text: 'All', value: 9999},
          { text: 'Month', value: 31 },
          { text: 'Week', value: 7 },
          { text: 'Day', value: 1 }
        ], 
      ToggleTotalCounts : true, 
      TotalCountsState : "Counts per second",
      loadingSensorList : false,
      loadingData : false,
      voltage_dataCollection : {},
      voltage_current : 0,
      sensor_last_online : 'unkown',
      SensorPlaceholder : '',


      pressure_dataCollection : {},
      Temperature_dataCollection : {},
      Humidity_dataCollection: {},

     
      minX : 10, 
      maxX : 100,

      Tot_Title : "Total counts", 
      Timestamps : [],
      LivetimeData : [],
      TotData : [],
      TotDataCps: [],

      Tot_dataCollection : {},
      LivetimeCollection : [],

      K_Title : "Potassium-40 concentration (Bq/kg)", 
      K_dataCollection : {},

      U_Title : "Uranium-238 concentration (Bq/kg)", 
      U_dataCollection : {},

      Th_Title : "Thorium-232 concentration (Bq/kg)", 
      Th_dataCollection : {},

      KUTh_options: {responsive:true,maintainAspectRatio:false,legend: {display : false}, scales:{xAxes:[{ticks: {}, type:'time',time:{displayFormats:{quarter:'MMM D'}}}]},        plugins: {
            zoom: {
                // Container for pan options
                pan: {
                    // Boolean to enable panning
                    enabled: true,

                    // Panning directions. Remove the appropriate direction to disable 
                    // Eg. 'y' would only allow panning in the y direction
                    mode: 'xy'
                },

                // Container for zoom options
                zoom: {
                    // Boolean to enable zooming
                    enabled: true,

                    // Zooming directions. Remove the appropriate direction to disable 
                    // Eg. 'y' would only allow zooming in the y direction
                    mode: 'xy',
                }
            }
        }  },

      voltage : [],
      voltageTimetamp : [],
      PTHtimestamp : [],
      pressure: [],
      temperature: [],
      humidity: [],
      potassium: [],
      uranium: [],
      thorium: [],

    }
  },
  components: {
    'Battery'   : Battery,
    'GeneralPlot' : GeneralPlot,
  },
  computed : {
    KUTh_options2() {
       let baseJSON = {responsive:true,maintainAspectRatio:false,legend: {display : true}, scales:{xAxes:[{ticks: {}, type:'time',time:{displayFormats:{quarter:'MMM D'}}}]},  }
       return baseJSON
      //return {responsive:true,maintainAspectRatio:false,legend: {display : false}, scales:{xAxes:[{ticks: {min : this.minX, max : this.maxX},  type:'time',time:{displayFormats:{quarter:'MMM D'}}}]},  }
    }, 
    SensorList () {
      return this.$store.getters.getSensorList
    },
    SelectedSensor(){
      return this.$store.getters.getSensorSelected
    },
        availableSensors () {
      let LocalList = this.$store.getters.getSensorList

      let output = [];
      LocalList.forEach(element => {
        let entry = {}
        entry.text = element.e_id
        entry.value = element.id
        output.push(entry)
      });


      return output


    }, 
  },

  watch: {
    SensorList(newList, oldList){
      this.makeSensorsLoadedToast(newList.length)
    },
    SelectedSensor (newSensor, oldSensor) {
    
      if (this.SensorPlaceholder != newSensor.id) {
        this.SensorPlaceholder = this.$store.getters.getSensorSelected.id
      }


      this.loadingSensorList =  false;
      this.loadingData = true
      this.GetDataFromServer(newSensor.id)

      if (newSensor.last_seen == null)  {this.sensor_last_online = 'never'}
      else { 
        let timestamp = new Date(parseInt(newSensor.last_seen)).toString()
        this.sensor_last_online = timestamp.substring(0, timestamp.length - 30)}
      }

  },
  mounted () {
    
    if (this.$store.getters.getSensorStatus != 'success' ) {
        this.loadingSensorList =  true;
        // Load sensor list from the server:
        this.$store.dispatch(SENSOR_REQUEST)
    }
    


    },
  methods: {
    SetDateLimits : function(){
      // Update the cutoff index for plotting
      this.cutoffPlaceholder = this.getDataCutoffIndex();

      // Reset the zoom levels
      this.ResetZooms()

      // Plot the values:
      this.PlotTotalCounts()
      this.plotKUTh();
      this.plotPTH();
      this.plotVoltage();
    },
    getDataCutoffIndex : function() {
      if (this.Timestamps.length < 2 ) {return -1*this.Timestamps.length}
      
      // Get last date
      let lastTimestamp = this.Timestamps[this.Timestamps.length - 1]
      let boundaryDate = new Date();

      // Subtract the period
      boundaryDate.setDate(lastTimestamp.getDate() - this.periodPlaceholder  );

      //console.log("plotting", this.periodPlaceholder, "days between", lastTimestamp.toLocaleString(), boundaryDate.toLocaleString())

      // find the position in the array
      let tsLength = this.Timestamps.length;
      for (let idx = (tsLength -1); idx >= 0; idx--) {
        if (this.Timestamps[idx] <= boundaryDate) {return (-1*(tsLength - idx - 2)) }
      }

      return -1 * tsLength
    },
    UpdateTotCntPlot : function() {
      if (this.TotalCountsState == "Counts per second") {this.TotalCountsState = "Total counts"}
      else ( this.TotalCountsState = "Counts per second" )

      // Plot the counts:
      this.PlotTotalCounts();
      
    },
    PlotTotalCounts : function (){
      // Determine if we have to plot totCnts or CPS
      let local_cnts;
      (this.ToggleTotalCounts ? local_cnts = this.TotDataCps : local_cnts = this.TotData)

      let tmp1 = this.Timestamps.slice(this.cutoffPlaceholder)
      let tmp2 = local_cnts.slice(this.cutoffPlaceholder)

      // Plot, taking the number of datapoints to plot into account
      this.Tot_dataCollection = this.GenerateDataCollection(tmp1, tmp2, 'Total', 'rgba(8, 8, 8, 0.4)', 'rgba(8, 8, 8, 0.5)', 'rgba(8, 8, 8, 1)')
    },
    plotKUTh : function() {
      let tmp1 = this.Timestamps.slice(this.cutoffPlaceholder)
      let tmpPot = this.potassium.slice(this.cutoffPlaceholder)
      let tmpUr = this.uranium.slice(this.cutoffPlaceholder)
      let tmpTh = this.thorium.slice(this.cutoffPlaceholder)

      this.K_dataCollection = this.GenerateDataCollection(tmp1, tmpPot, 'Potassium', 'rgba(193, 1, 1, 0.4)', 'rgba(193, 1, 1, 0.5)', 'rgba(193, 1, 1, 1)')
      this.U_dataCollection = this.GenerateDataCollection(tmp1, tmpUr, 'Uranium', 'rgba(1, 193, 1, 0.4)', 'rgba(1, 193, 1, 0.5)', 'rgba(1, 193, 1, 1)')
      this.Th_dataCollection = this.GenerateDataCollection(tmp1, tmpTh, 'Thorium', 'rgba(1,91,193, 0.4)', 'rgba(1,91,193, 0.5)', 'rgba(1,91,193, 1)')
    },
    plotPTH : function(){
      let tmp1 = this.PTHtimestamp.slice(this.cutoffPlaceholder)
      let tmpPress = this.pressure.slice(this.cutoffPlaceholder)
      let tmpTemp = this.temperature.slice(this.cutoffPlaceholder)
      let tmpHum = this.humidity.slice(this.cutoffPlaceholder)

      this.pressure_dataCollection = this.GenerateDataCollection(tmp1, tmpPress, 'Pressure', 'rgba(8, 8, 8, 0.4)', 'rgba(8, 8, 8, 0.5)', 'rgba(8, 8, 8, 1)')
      this.Temperature_dataCollection = this.GenerateDataCollection(tmp1, tmpTemp, 'Temperature', 'rgba(8, 8, 8, 0.4)', 'rgba(8, 8, 8, 0.5)', 'rgba(8, 8, 8, 1)')
      this.Humidity_dataCollection = this.GenerateDataCollection(tmp1, tmpHum, 'Humidity', 'rgba(8, 8, 8, 0.4)', 'rgba(8, 8, 8, 0.5)', 'rgba(8, 8, 8, 1)')


    },
    plotVoltage : function(){
      let tmp1 = this.voltageTimetamp.slice(this.cutoffPlaceholder)
      let tmp2 = this.voltage.slice(this.cutoffPlaceholder)

      this.voltage_dataCollection = this.GenerateDataCollection(tmp1, tmp2, 'Voltage', 'rgba(8, 8, 8, 0.4)', 'rgba(8, 8, 8, 0.5)', 'rgba(8, 8, 8, 1)')
    },
    SelectNewSensor: function(sensor) { 
       this.$store.commit(SENSOR_SELECT, sensor)
      },
    makeSensorsLoadedToast(count) {
        this.$bvToast.toast(`Loaded sensors from server. ${count} sensors available`, {
          title: 'Server message',
          autoHideDelay: 5000,
          variant: 'success',
          toaster: 'b-toaster-bottom-right',
          class: 'offSetFromTop',
          solid: true,
        })
    },
    NoDataToast() {
        this.$bvToast.toast(`Warning: no data found for sensor. ${this.SelectedSensor.e_id} `, {
          title: 'Server message',
          autoHideDelay: 5000,
          variant: 'danger',
          toaster: 'b-toaster-bottom-right',
          solid: true,
        })
    },
    DataToast(NumberOfRecord) {
        this.$bvToast.toast(`Loaded. ${NumberOfRecord} datapoints from server`, {
          title: 'Server message',
          autoHideDelay: 5000,
          variant: 'success',
          toaster: 'b-toaster-bottom-right',
          solid: true,
        })
    },
    ResetZooms(){
      this.$refs.totalPlot.resetZoom()
      
      this.$refs.kPlot.resetZoom()
      this.$refs.uPlot.resetZoom()
      this.$refs.thPlot.resetZoom()

      this.$refs.pressPlot.resetZoom()
      this.$refs.tempPlot.resetZoom()
      this.$refs.humPlot.resetZoom()

    },
    ClearData () {

      
      this.Timestamps = []
      this.voltage =  []
      this.voltageTimetamp =  []
      this.PTHtimestamp =  []
      this.pressure =  []
      this.temperature =  []
      this.humidity =  []
      this.potassium =  []
      this.uranium =  []
      this.thorium =  []

      this.cutoffPlaceholder = this.getDataCutoffIndex();
      this.PlotTotalCounts()
      this.plotKUTh();
      this.plotPTH();
      this.plotVoltage();

    },
    GetDataFromServer (sensorID){
      let ConnectionString = `/api/v1/data?
                              stabData=true
                              &fields=Timestamp
                              &fields=Livetime
                              &fields=Realtime
                              &fields=Total
                              &fields=K40
                              &fields=U238
                              &fields=Th232
                              &fields=Press
                              &fields=Temp
                              &fields=Hum
                              &fields=Voltage
                              &sensor_id=` + sensorID
      // Remove spaces:
      ConnectionString = ConnectionString.replace(/\s+/g, '');      
      this.$http.get(ConnectionString)
        .then(response => {
          //console.log(response.data)
          if (response.data.length == 0) { this.ClearData(); this.NoDataToast()}     
          else {
            this.DataToast(response.data.length)
            // JSON responses are automatically parsed.
      
            
            let PlotDataX = []
            let Total = []
            let TotalCps = []
            let Potassium = []
            let Uranium = []
            let Thorium = []
            let Livetime = []

            let voltageTimetamp = []
            let voltage = []

            let PTHtimestamp = []
            let pressure = []
            let temperature = []
            let humidity = []

            // Sort the data
            response.data.forEach(element => {

              if (element.Timestamp == null) {return}
              // Parse the data:
              if ((element.Voltage != null )) {
                voltageTimetamp.push(new Date(parseInt(element.Timestamp)))
                voltage.push(this.CalculateBatteryPercentage(element.Voltage).toFixed(2))
              }

              if ((element.Press != null )) {
                PTHtimestamp.push(new Date(parseInt(element.Timestamp)))
                pressure.push(element.Press)
                temperature.push(element.Temp)
                humidity.push(element.Hum)  
              }
 
              PlotDataX.push(new Date(parseInt(element.Timestamp)))
              Total.push(element.Total)
              TotalCps.push(element.Total/element.Livetime)
              Potassium.push(element.K40)
              Uranium.push(element.U238)
              Thorium.push(element.Th232)
              Livetime.push(element.Livetime)
              
            });
      
            // Add data to graphs
            this.voltage_current = parseFloat(voltage[voltage.length - 1]);


            // Copy the data to local variables:
            // This not done directly because it needs to update the plots only when all data is in
            this.voltageTimetamp = voltageTimetamp
            this.voltage = voltage

            this.PTHtimestamp = PTHtimestamp
            this.pressure = pressure
            this.temperature = temperature
            this.humidity = humidity



            this.Timestamps = PlotDataX
            this.LivetimeData = Livetime
            this.TotData = Total
            this.TotDataCps = TotalCps
            this.potassium = Potassium
            this.uranium = Uranium
            this.thorium = Thorium

            // Plot the values:
            this.cutoffPlaceholder = this.getDataCutoffIndex();
            this.PlotTotalCounts()
            this.plotKUTh();
            this.plotPTH();
            this.plotVoltage();
            }
          
          this.loadingData = false;
          
        })
        .catch(e => {
          console.log(e)
          this.loadingData = false;
          
        })

    },
    CalculateBatteryPercentage(value) {
      // Convert the voltage readings to a percentage:

      // Table in mV
      let VoltageTable = [
        [12700, 100],
        [12500, 90],
        [12420, 80],
        [12320, 70],
        [12200, 60],
        [12060, 50],
        [11900, 40],
        [11790, 30],
        [11580, 20],
        [11310, 10],
        [10500, 0],
      ]
      if (value > VoltageTable[0][0]) { return 100 } 

      let upper = VoltageTable[0][0]
      let lower 

      for (let idx = 1; idx < VoltageTable.length; idx++) { 
        lower = VoltageTable[idx][0]

        // Exact match
        if (value == lower) {return VoltageTable[idx][1]}

        // Linear interpolation
        if (value > lower ) {    
           let Delta = (VoltageTable[idx - 1][1] - VoltageTable[idx][1]) / (upper - lower)
           return VoltageTable[idx][1] + (value - lower) * Delta
        }
        
        upper = lower
      }

      return 0
      
    },
    GenerateDataCollection (xval, yval, _label, bordCol, bgCol, Pointbgcol) {
      return {
          labels: xval,
          datasets: [
            {
              label: _label,
              fill: false,
              borderColor: bordCol,
              backgroundColor: bgCol,
              pointBackgroundColor: Pointbgcol,
              data: yval,
              
            }
          ]
        }
    },
  }
}



</script>

<style>

.background {
  background-color : rgb(247, 247, 248);
}

.test {
  background-color : green;
}


.RoundBox {
    box-shadow: 0 0 0 1px rgba(211,211,211,0.5) inset;
    border: solid 7px rgb(247, 247, 248);
    border-radius : 15px;
    background: linear-gradient(180deg, #f2f2f2 45px, rgba(211,211,211,0.5), white 46px);

  }

  .filler:after {
      content: '\200b';
  }


.customTopOffset2 {
  width:100%;
 height:100%;

 margin:0 auto;
 background:#f7f7f7;
 position:absolute;
 left:50%;
 top:50%;
 margin-left:-50%;
 margin-top:-50%;
}

</style>